import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c316e83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-info" }
const _hoisted_2 = { class: "el-dropdown-link" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_password = _resolveComponent("password")!
  const _component_avatar = _resolveComponent("avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dropdown, null, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_dropdown_item, {
              icon: "el-icon-s-tools",
              onClick: _ctx.handleUpdatePassWord
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 修改密码 ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_dropdown_item, {
              icon: "el-icon-picture",
              onClick: _ctx.handleUploadAvatar
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 修改头像 ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_dropdown_item, {
              icon: "el-icon-error",
              onClick: _ctx.handleExit,
              divided: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 退出登录 ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            size: "small",
            src: _ctx.avatar,
            fit: "fill",
            shape: "square"
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.name), 1),
          _hoisted_4
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_password, { ref: "passwordRef" }, null, 512),
    _createVNode(_component_avatar, {
      ref: "avatarRef",
      onUploadavatar: _ctx.uploadavatar
    }, null, 8, ["onUploadavatar"])
  ]))
}